import React, { Component } from 'react'
import queryString from 'querystringify'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import IFrameResizer from 'react-iframe-resizer-super'

class IFrame extends Component {
  generateUrl () {
    const {
      forwardQueryParams,
      location,
      url
    } = this.props

    if (forwardQueryParams === 'yes') {
      const [ path, query = '' ] = url.split('?')
      const existingQuery = queryString.parse(query)
      const combinedQuery = { ...existingQuery, ...location.query }
      return `${path}?${queryString.stringify(combinedQuery)}`
    }

    return url
  }

  render () {
    const { classNames } = this.props

    return (
      <div className={classNames.root}>
        <IFrameResizer
          src={this.generateUrl()}
          scrolling='no'
          style={{ width: '100%', border: 'none' }}
        />
      </div>
    )
  }
}

export default compose(
  withRouter,
  withStyles(styles)
)(IFrame)



// WEBPACK FOOTER //
// ./components/ui/IFrame/index.js